import React from 'react';
const AIProfileSuggestionsWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden h-full p-6" data-id="element-499">
      <div className="flex flex-col h-full" data-id="element-500">
        <div className="flex items-center mb-6" data-id="element-501">
          <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-pink-500 mr-3" data-id="element-502">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-503" />
          </div>
          <div data-id="element-504">
            <h2 className="text-base font-semibold text-gray-800" data-id="element-505">
              Suggerimenti AI
            </h2>
            <p className="text-xs text-gray-500 mt-1" data-id="element-506">
              Powered by EIIS Intelligence
            </p>
          </div>
        </div>
        <div className="space-y-4 flex-grow" data-id="element-507">
          <div className="p-4 bg-white rounded-lg border border-gray-200" data-id="element-508">
            <h3 className="font-medium text-gray-800 mb-2" data-id="element-509">
              Condividi il tuo progetto ESG Milano
            </h3>
            <p className="text-sm text-gray-600" data-id="element-510">
              Basato sui tuoi interessi, 5 professionisti simili hanno
              pubblicato case study simili con ottimi risultati
            </p>
          </div>
          <div className="p-4 bg-white rounded-lg border border-gray-200" data-id="element-511">
            <h3 className="font-medium text-gray-800 mb-2" data-id="element-512">
              Partecipa alla discussione CSRD
            </h3>
            <p className="text-sm text-gray-600" data-id="element-513">
              Il tuo background in reporting ESG è perfetto per il thread attivo
              su Green Finance Italia
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default AIProfileSuggestionsWidget;